import React, { createContext, useContext, useState } from "react";

const UICtx = createContext({});

export function UIProvider({ children }) {
  const [role, setRole] = useState("plant_head");
  const [askContext, setAskContext] = useState(null); // { question, source }

  const askOIM = (question, source = null) => setAskContext({ question, source, ts: Date.now() });
  const consumeAsk = () => { const c = askContext; setAskContext(null); return c; };

  return (
    <UICtx.Provider value={{ role, setRole, askOIM, consumeAsk, askContext }}>
      {children}
    </UICtx.Provider>
  );
}

export const useUI = () => useContext(UICtx);
